export const runtimeConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? "/trpc",
  defaultDevEmail: import.meta.env.VITE_DEFAULT_EMAIL ?? "test@impacto.dev",
  // Версия сборки. Едет с каждым отчётом о сбое: без неё непонятно, чинит ли
  // релиз ошибку или её всё ещё видят те, у кого закешировался старый фронт.
  release: import.meta.env.VITE_RELEASE ?? "dev",
};
